<script lang="ts">
    import { PaginationMeta } from "@apps/iloom_customization/types/PaginationMeta";
    import cn from "classnames";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import FirstPageIcon from "./icons/FirstPageIcon.svelte";
    import LastPageIcon from "./icons/LastPageIcon.svelte";
    import NextPageIcon from "./icons/NextPageIcon.svelte";
    import PrevPageIcon from "./icons/PrevPageIcon.svelte";

    export let meta: PaginationMeta;

    $: totalPages = Math.ceil(meta.total / meta.limit);
    $: currentPage = meta.offset / meta.limit + 1;

    const dispatch = createEventDispatcher();

    const onFirstPageHandle = () => {
        dispatch("changePage", 1);
    };

    const onPrevPageHandle = () => {
        dispatch("changePage", currentPage - 1);
    };

    const onNextPageHandle = () => {
        dispatch("changePage", currentPage + 1);
    };

    const onLastPageHandle = () => {
        dispatch("changePage", totalPages);
    };

    const onChangePageHandle = (page: number) => {
        dispatch("changePage", page);
    };
</script>

{#if totalPages > 0}
    <div class="gw-pagination">
        <BaseButton disabled={currentPage === 1} on:click={onFirstPageHandle}>
            <FirstPageIcon />
        </BaseButton>
        <BaseButton disabled={currentPage === 1} on:click={onPrevPageHandle}>
            <PrevPageIcon />
        </BaseButton>
        <div class="gw-pagination-pages">
            {#each new Array(totalPages).fill(null) as _, index}
                <BaseButton
                    class={cn("gw-pagination-page-btn", {
                        "gw-pagination-page-btn--active":
                            index + 1 === currentPage,
                    })}
                    on:click={() => onChangePageHandle(index + 1)}
                >
                    {index + 1}
                </BaseButton>
            {/each}
        </div>
        <BaseButton
            disabled={currentPage === totalPages}
            on:click={onNextPageHandle}
        >
            <NextPageIcon />
        </BaseButton>
        <BaseButton
            disabled={currentPage === totalPages}
            on:click={onLastPageHandle}
        >
            <LastPageIcon />
        </BaseButton>
    </div>
{/if}

<style lang="postcss">
    .gw-pagination {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 21px;
    }

    .gw-pagination-pages {
        display: flex;
        align-items: center;
        gap: 32px;
    }

    :global(.gw-pagination-page-btn) {
        position: relative;
        font-size: 16px;
        color: #000;
        z-index: 1;
    }

    :global(.gw-pagination-page-btn.gw-pagination-page-btn--active) {
        &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: -1;
            width: 31px;
            height: 31px;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            background-color: #f2efea;
        }
    }

    :global(.gw-pagination .gw-btn:disabled) {
        cursor: auto;
        opacity: 0.7;
    }
</style>
